// ESM default export so the browser can import it
const CONFIG = {
  // Base URL of your Flask API (no trailing slash)
   API_BASE: "https://api.factorbench.com",
  // For local dev, comment the line above and uncomment the one below:
  //API_BASE: "http://127.0.0.1:4998",

  CREATE_CHECKOUT_SESSION:
    "https://elktqroruyyrfnybqdkm.supabase.co/functions/v1/create-checkout-session",
  CREATE_BILLINGPORTAL_SESSION:
    "https://elktqroruyyrfnybqdkm.supabase.co/functions/v1/create-billingportal-session",
};

// Back-compat alias for code that still references API_URL
CONFIG.API_URL = CONFIG.API_BASE;

export default CONFIG;